import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useAppContext } from '../context/AppContext';
import { computeLeadScore } from '../utils/leadScore';
import { sendLead, buildLeadPayload } from '../utils/sendLead';
export const EmailCapture = () => {
  const {
    setCurrentPage,
    userName,
    setUserName,
    userEmail,
    setUserEmail,
    answers,
    setLeadScore
  } = useAppContext();
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async () => {
    if (!userName.trim() || !userEmail.trim()) {
      setError('Por favor completa todos los campos');
      return;
    }
    if (!userEmail.includes('@') || !userEmail.includes('.')) {
      setError('Por favor ingresa un email válido');
      return;
    }
    setError('');
    setIsSubmitting(true);
    // 1) Compute lead score from quiz answers
    const score = computeLeadScore(answers);
    setLeadScore(score);
    // 2) Build payload and send to webhook (or log to console if not configured)
    const payload = buildLeadPayload(userName, userEmail, score, answers);
    await sendLead(payload);
    // 3) Advance to the loading/results flow
    setCurrentPage('loading');
  };
  return <div className="min-h-screen bg-bg text-text flex items-center justify-center py-12 px-5" data-id="element-96">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="max-w-[520px] w-full" data-id="element-97">
        <div className="mb-8" data-id="element-98">
          <span className="inline-block text-[12px] font-semibold tracking-[0.15em] uppercase text-primary mb-4" data-id="element-99">
            Test completado
          </span>
          <h2 className="text-[28px] sm:text-[34px] font-extrabold text-dark leading-[1.15] tracking-tight mb-3" data-id="element-100">
            Tu diagnóstico está listo.
          </h2>
          <p className="text-[16px] text-textlight leading-[1.6]" data-id="element-101">
            Ingresa tus datos para acceder a tu perfil personalizado y plan de
            acción.
          </p>
        </div>

        <div className="space-y-4 mb-6" data-id="element-102">
          <div data-id="element-103">
            <label className="block text-[13px] font-semibold text-dark mb-1.5" data-id="element-104">
              Nombre completo
            </label>
            <input type="text" value={userName} onChange={e => setUserName(e.target.value)} disabled={isSubmitting} className="w-full bg-white border border-border rounded-lg py-3.5 px-4 text-[15px] text-text outline-none focus:border-primary focus:ring-2 focus:ring-primary/10 transition-all placeholder:text-textlight/60 disabled:opacity-60" placeholder="Tu nombre completo" data-id="element-105" />
          </div>
          <div data-id="element-106">
            <label className="block text-[13px] font-semibold text-dark mb-1.5" data-id="element-107">
              Email profesional
            </label>
            <input type="email" value={userEmail} onChange={e => setUserEmail(e.target.value)} disabled={isSubmitting} className="w-full bg-white border border-border rounded-lg py-3.5 px-4 text-[15px] text-text outline-none focus:border-primary focus:ring-2 focus:ring-primary/10 transition-all placeholder:text-textlight/60 disabled:opacity-60" placeholder="tu@email.com" data-id="element-108" />
          </div>
          {error && <p className="text-danger text-[13px]" data-id="element-109">{error}</p>}
        </div>

        <button onClick={handleSubmit} disabled={isSubmitting} className="bg-primary hover:bg-primary-hover text-white border-none rounded-xl py-4 px-8 text-[16px] font-bold cursor-pointer w-full block transition-all duration-200 shadow-primary hover:-translate-y-0.5 disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:translate-y-0" data-id="element-110">
          {isSubmitting ? 'Procesando…' : 'Ver mi resultado →'}
        </button>

        <div className="text-[12px] text-textlight mt-5 flex items-center justify-center gap-1.5" data-id="element-111">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="shrink-0" data-id="element-112">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-113" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-114" />
          </svg>
          Tu información está protegida. Nunca compartimos tus datos.
        </div>
      </motion.div>
    </div>;
};